// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* loading animation */
.spinner,
.spinner:before,
.spinner:after {
  width: 4px;
  height: 20px;
  background-color: #237bc2;
  border-radius: 0px;
}

.spinner {
  display: inline-block;
  position: relative;
}

.spinner:before,
.spinner:after {
  content: "";
  position: absolute;
  display: block;
  top: 0px;
}

.spinner:before {
  left: -6px;
}

.spinner:after {
  left: 6px;
}

@keyframes bounce-middle {
  0% {
    height: 4px;
    margin-top: 8px;
    margin-bottom: 8px;
    background-color: transparent;
  }
  50% {
    height: 20px;
    margin-top: 0px;
    margin-bottom: 0px;
    background-color: #237bc2;
  }
  100% {
    height: 4px;
    margin-top: 8px;
    margin-bottom: 8px;
    background-color: transparent;
  }
}

.spinner-bounce-middle {
  animation: bounce-middle 0.6s ease 0.1s infinite;
  position: absolute;
  top: 50%;
  left: 50%;
}

.spinner-bounce-middle:before,
.spinner-bounce-middle:after {
  top: 50%;
  transform: translateY(-10px) translateZ(0);
}

.spinner-bounce-middle:before {
  animation: bounce-middle 0.6s ease 0s infinite;
}

.spinner-bounce-middle:after {
  animation: bounce-middle 0.6s ease 0.2s infinite;
}

`, "",{"version":3,"sources":["webpack://./src/app/components/loading-rows-overlay/loading-rows-overlay.component.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;;;EAGE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAuBA;EACE;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,6BAA6B;EAC/B;EACA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,6BAA6B;EAC/B;AACF;;AAEA;EAEE,gDAAgD;EAChD,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;;EAEE,QAAQ;EAER,0CAA0C;AAC5C;;AAEA;EAEE,8CAA8C;AAChD;;AAEA;EAEE,gDAAgD;AAClD","sourcesContent":["/* loading animation */\n.spinner,\n.spinner:before,\n.spinner:after {\n  width: 4px;\n  height: 20px;\n  background-color: #237bc2;\n  border-radius: 0px;\n}\n\n.spinner {\n  display: inline-block;\n  position: relative;\n}\n\n.spinner:before,\n.spinner:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  top: 0px;\n}\n\n.spinner:before {\n  left: -6px;\n}\n\n.spinner:after {\n  left: 6px;\n}\n\n@-webkit-keyframes bounce-middle {\n  0% {\n    height: 4px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    background-color: transparent;\n  }\n  50% {\n    height: 20px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n    background-color: #237bc2;\n  }\n  100% {\n    height: 4px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    background-color: transparent;\n  }\n}\n\n@keyframes bounce-middle {\n  0% {\n    height: 4px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    background-color: transparent;\n  }\n  50% {\n    height: 20px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n    background-color: #237bc2;\n  }\n  100% {\n    height: 4px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    background-color: transparent;\n  }\n}\n\n.spinner-bounce-middle {\n  -webkit-animation: bounce-middle 0.6s ease 0.1s infinite;\n  animation: bounce-middle 0.6s ease 0.1s infinite;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n\n.spinner-bounce-middle:before,\n.spinner-bounce-middle:after {\n  top: 50%;\n  -webkit-transform: translateY(-10px) translateZ(0);\n  transform: translateY(-10px) translateZ(0);\n}\n\n.spinner-bounce-middle:before {\n  -webkit-animation: bounce-middle 0.6s ease 0s infinite;\n  animation: bounce-middle 0.6s ease 0s infinite;\n}\n\n.spinner-bounce-middle:after {\n  -webkit-animation: bounce-middle 0.6s ease 0.2s infinite;\n  animation: bounce-middle 0.6s ease 0.2s infinite;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
